import { classroomIntakeError } from "@/lib/api/classroomIntake";
import type { ClassroomIntakePreview } from "@/lib/api/classroomIntake";
import { reasonOnError } from "@/lib/api/commitSeams";
import { rowName } from "./intake-plan";

const REFUSALS: Record<string, string> = {
  preview_changed: "Classroom changed since you reviewed it. Read the current evidence and choose how to keep your decisions.",
  already_linked: "This course is already in IMAM.",
  decision_conflict: "This course was already brought in with different choices. This confirmation changed nothing.",
  term_closed: "The chosen term is closed. Choose a term that is not closed.",
};

/** Preserve the server's sentence and record ids, resolving names only for display. */
export function intakeFailure(error: unknown, preview?: ClassroomIntakePreview): string {
  const read = classroomIntakeError(error);
  const reason = reasonOnError(error);
  const prefix = read?.code ? REFUSALS[read.code] : undefined;
  const message = reason?.message ?? read?.message;
  const sentence = [prefix, message && !["Conflict", "Not Found"].includes(message) ? message : null].filter(Boolean).join(" ") || "The course could not be read. Your choices are kept.";
  const ids = [...new Set([...(read?.rows ?? []), ...(reason?.ids ?? [])])];
  const rows = [...(preview?.teachers ?? []), ...(preview?.students ?? [])];
  return sentence + (ids.length ? ` ${ids.length === 1 ? "Row" : "Rows"}: ${ids.map(id => { const row = rows.find(row => row.provider_user_id === id); return row ? `${rowName(row)} (${id})` : id; }).join(", ")}.` : "");
}
